// extracted by mini-css-extract-plugin
export default {"session":"Account_session__MmzEg"};